// @flow
import { Component, OnInit, ViewChild, ElementRef, OnDestroy, HostListener  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import * as $ from 'jquery';
import { Router, ActivatedRoute } from '@angular/router';
import { HotkeysService, Hotkey } from 'angular2-hotkeys';
import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter, NgbModal, NgbModalRef, NgbModalConfig, NgbDate } from '@ng-bootstrap/ng-bootstrap';

import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
var moment = require('moment');
import { DatePipe, formatDate } from '@angular/common';
import { date } from 'ngx-custom-validators/src/app/date/validator';
import Drift from 'drift-zoom';
import * as XLSX from 'xlsx';
import bb from 'billboard.js';
import { UtilityService } from '../shared/services/Utility.service';
import { EChartOption } from "echarts";

@Component({
  selector: 'warehousedashboard',
  template: require('./WarehouseDashboard.html'),
  styles:[`
    .bs-datepicker{
      top: 150px !important;
    }
    `],
})

export class WarehouseDashboardComponent implements OnInit, OnDestroy{
  
  static parameters = [HttpClient, HotkeysService, Router,  NgbModal, UtilityService, NgbModalConfig, BsDatepickerConfig, ];
  @ViewChild('CycleConfig') CycleConfig: ElementRef;  
  cycleConfigReference: NgbModalRef;
  busy: Subscription;
  loading: boolean = true;
  dateFormat: any; bsConfig: BsDatepickerConfig;
  unitInfo: any;
  createdBy: any;
  selecteDate: any;
  constructor(private http: HttpClient, private router: Router, private hotkeysService: HotkeysService, private modalService: NgbModal, private datePipe: DatePipe, public _bsDatepickerConfig: BsDatepickerConfig) {
    this.http = http;
    this.router = router;
    this.hotkeysService = hotkeysService;
    this.modalService = modalService;
    this.datePipe = datePipe;  

    this.dateFormat = JSON.parse(localStorage.getItem('permission'))[0];
    this.bsConfig = Object.assign(new BsDatepickerConfig(), { dateInputFormat: 'DD-MMM-YYYY', containerClass: this.dateFormat.dateColorTheme});
    this._bsDatepickerConfig.dateInputFormat = 'DD-MMM-YYYY';
  
    this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
    this.createdBy = this.unitInfo._id;
  }

  
  ngOnInit(): void {
    this.selecteDate = new Date();
    this.getWarehouseDashboardSummary();
    this.GetWarehouseDashboardDetail();
    // this.startAutoCycle();
    try {
      // console.table(this.tileAutoCycleConfig);
      if ("SystemConfigDetails" in localStorage) {
        var data = JSON.parse(localStorage.getItem('SystemConfigDetails'))
  
        let totalBills = data.filter(function (item) {
          return item.Config_Name === 'WAREHOUSE DASHBOARD FLASH TIME FOR TOTAL BILLS(BILL WISE)'
        });
        let totalBillsvalue = this.f_chknum(totalBills.length > 0 ? totalBills[0].Config_Value : 0);
        this.tileAutoCycleConfig.find(t => t.warehouseId === 1).billWiseInterval = totalBillsvalue;
        
        let totalroute = data.filter(function (item) {
          return item.Config_Name === 'WAREHOUSE DASHBOARD FLASH TIME FOR TOTAL BILLS(ROUTE WISE)'
        });
        let totalroutevalue = this.f_chknum(totalroute.length > 0 ? totalroute[0].Config_Value : 0);
        this.tileAutoCycleConfig.find(t => t.warehouseId === 1).routeWiseInterval = totalroutevalue;
  
        let pendingtoAsign = data.filter(function (item) {
          return item.Config_Name === 'WAREHOUSE DASHBOARD FLASH TIME FOR PENDING TO ASSIGN'
        });
        let pendingtoAsignvalue = this.f_chknum(pendingtoAsign.length > 0 ? pendingtoAsign[0].Config_Value : 0);
        this.tileAutoCycleConfig.find(t => t.warehouseId === 2).interval = pendingtoAsignvalue;
        
        let picking = data.filter(function (item) {
          return item.Config_Name === 'WAREHOUSE DASHBOARD FLASH TIME FOR PICKING'
        });
        let pickingvalue = this.f_chknum(picking.length > 0 ? picking[0].Config_Value : 0);
        this.tileAutoCycleConfig.find(t => t.warehouseId === 3).interval = pickingvalue;
  
        let checking = data.filter(function (item) {
          return item.Config_Name === 'WAREHOUSE DASHBOARD FLASH TIME FOR CHECKING'
        });
        let checkingvalue = this.f_chknum(checking.length > 0 ? checking[0].Config_Value : 0);
        this.tileAutoCycleConfig.find(t => t.warehouseId === 4).interval = checkingvalue;
  
        let dispatchRW = data.filter(function (item) {
          return item.Config_Name === 'WAREHOUSE DASHBOARD FLASH TIME FOR DISPATCH(ROUTE WISE)'
        });
        let dispatchRWvalue = this.f_chknum(dispatchRW.length > 0 ? dispatchRW[0].Config_Value : 0);
        this.tileAutoCycleConfig.find(t => t.warehouseId === 5).dispatchRouteInterval = dispatchRWvalue;
        
        let dispatchSW = data.filter(function (item) {
          return item.Config_Name === 'WAREHOUSE DASHBOARD FLASH TIME FOR DISPATCH(SALESMAN WISE)'
        });
        let dispatchSWvalue = this.f_chknum(dispatchSW.length > 0 ? dispatchSW[0].Config_Value : 0);
        this.tileAutoCycleConfig.find(t => t.warehouseId === 5).dispatchSalesmanInterval = dispatchSWvalue;
        

        let rowload = data.filter(function (item) {
          return item.Config_Name === 'WAREHOUSE DASHBOARD FLASH TIME FOR ROW LOAD'
        });
  
        let rowloadvalue = this.f_chknum(rowload.length > 0 ? rowload[0].Config_Value : 0);
        this.tileAutoCycleConfig.find(t => t.warehouseId === 6).interval = rowloadvalue;
    
        // console.table(this.tileAutoCycleConfig);

      }
    } catch (error) {
      console.log('🚀 ~ error while setting permission values:', error);
    }
  }
  
  ngOnDestroy(): void {
    // Clear any active timer to prevent memory leaks
    console.log('ngDestroy called :this.autoCycleTimer:: ', this.autoCycleTimer);
    if (this.autoCycleTimer) {
      clearTimeout(this.autoCycleTimer);
      console.log('🚀 ~ this.autoCycleTimer:', this.autoCycleTimer)
      
      this.autoCycleTimer = null;
    }
    console.log('🚀 ~ this.autoCycleTimer:', this.autoCycleTimer)
  }

  activeWarehouse: number = 0;
  setactiveWarehouse(buttonNumber: number): void {
      // 1. Cancel existing auto-cycle timer
    if (this.autoCycleTimer) {
      clearTimeout(this.autoCycleTimer);
      this.autoCycleTimer = null;
    }
    // if (this.activeWarehouse !== buttonNumber ) {
      this.activeWarehouse = buttonNumber;
      if(buttonNumber === 1){
        this.activeCstabs = 2;
        this.GetWarehouseDashboardDetail("TB", "BW");
      }else if(buttonNumber === 2){
        this.GetWarehouseDashboardDetail("PTA");
      }else if(buttonNumber === 3){
        this.GetWarehouseDashboardDetail("PC");
      }else if(buttonNumber === 4){
        this.GetWarehouseDashboardDetail("CK");
      }else if(buttonNumber === 5){
        this.activeDispatchTabs = 1;
        this.GetWarehouseDashboardDetail("DP", "RW"); 
      }else if(buttonNumber === 6){
        // this.activeDispatchTabs = 2;
        this.GetWarehouseDashboardDetail("RL", "SM");
      }
    // }

    // Update autoCycleIndex so startAutoCycle() knows which tile you're on
    const foundIndex = this.tileAutoCycleConfig.findIndex(
      t => t.warehouseId === buttonNumber
    );
    this.autoCycleIndex = foundIndex !== -1 ? foundIndex : 0;

     // 4. **Pause auto-cycle when user manually clicks a tile**
    this.isCycling = false;
  }
  
  activeCstabs: number = 2;
  setactiveCstabs(buttonNumber: number): void {
    if (this.activeCstabs !== buttonNumber) {
      this.activeCstabs = buttonNumber;
      // if(buttonNumber === 1){
      //   this.GetWarehouseDashboardDetail("TB", "RW");
      // }else{
      //   this.GetWarehouseDashboardDetail("TB", "BW");
      // }
      if(buttonNumber == 1){
        this.GetWarehouseDashboardDetail("TB", "RW");
      }else if(buttonNumber == 2){
        this.GetWarehouseDashboardDetail("TB", "BW");
      }else if(buttonNumber == 3){
        this.GetWarehouseDashboardDetail("TB", "SW");
      }else if(buttonNumber ==4 ){
        this.GetWarehouseDashboardDetail("TB", "AW");
      }else if(buttonNumber ==5){
        this.GetWarehouseDashboardDetail("TB", "BW");  
      }
    }
  }
  
  
  activeDispatchTabs: number = 1;
  setactiveDispatchTabs(buttonNumber: number): void {
    if (this.activeDispatchTabs !== buttonNumber) {
      this.activeDispatchTabs = buttonNumber;
      if(buttonNumber === 1){
        this.GetWarehouseDashboardDetail("DP", "RW");
      }else{
        this.GetWarehouseDashboardDetail("DP", "SM");
      }
    }
  }
  
  
  
  
  
  
  
  // isChartInitialized: boolean = false;
  // ngAfterViewChecked(): void {
  //     if (this.activeWarehouse === 1 && ! this.isChartInitialized) {
  //       const barChartElement = document.getElementById('barChart');
  //       if (barChartElement && !barChartElement.hasChildNodes()) {
  //         this.initBarChart();
  //         this.isChartInitialized = false;
  //       }
  //     } 
  //   }
  
  // ["x", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00"],
  
  
  inittotalBills(x , prevDay, today): void {
    bb.generate({
      data: {
        x: "x",
        xFormat: "%H:%M", // Define the format of the x-axis data
        columns: [
          // Define the x-axis values as actual time strings
          // ["x", "01:00", "02:00","03:00","04:00","05:00","06:00","07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"],
          // ["Previous Day", 30, 200, 100, 400, 150, 250, 30, 200, 100, 400, 150, 250, 400, 30, 200, 100, 400, 150, 250, 400, 30, 200, 100],
          // ["Today", 130, 340, 200, 500, 250, 350,130, 340, 200, 500, 250, 350, 500, 130, 340, 200, 500, 250, 350, 500, 130, 340, 200]

          
          // ["x", "00:01", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"],
          // ["Previous Day", 0, 0, 0, 0, 0, 2, 0, 0, 19, 26, 53, 54, 46, 34, 44, 27, 34, 7, 3, 2, 3, 6, 13, 5],
          // ["Today",        1, 0, 0, 0, 0, 6, 0, 0, 8, 24, 49, 44, 33, 27, 12, 0, 0, 0, 0, 0, 0, 15, 35, 0]
          
          
          

          
          ["x", ...x],
          ["Previous Day", ...prevDay],
          ["Today", ...today ],
        ],
        type: "line", // Specify the chart type
        // types: {
        //   "Previous Day": "spline",
        //   "Today": "spline",
        // }
      },
      axis: {
        
        x: {
          type: "timeseries", // Define the x-axis type as timeseries
          // localtime: true,   // Use UTC or not
          tick: {
            // format: "%H:%M",  // Display the time in hour:minute format
            // fit: true,        // Ensure the ticks fit into the chart
            // multiline: true,
            // rotate: 65,
            centered: true,    
            fit: true,
            format: "%H:%M",
          },
        },
      },
      // padding: {
      //   left: 50,   
      //   right: 50,
      // },
      color: {
              pattern: ["#FF8000", "#3C8FA8"], 
            },
      grid: {
        x: {
          show: true, // Enable vertical gridlines
        },
      },
      size: {
        height: 160, // Set chart height
      },
      bindto: "#totalBills", // Bind the chart to the element with ID "totalBills"
    });
  }
  

  initPendingAssign(x, Prev_Pending_To_Assign, Pending_To_Assign): void {
    bb.generate({
      data: {
        x: "x",
        xFormat: "%H:%M", // Define the format of the x-axis data
        columns: [
          // Define the x-axis values as actual time strings
          // ["x", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00"],
          // ["Previous Day", 30, 200, 100, 400, 150, 250, 30, 200, 100, 400, 150, 250, 400],
          // ["Today", 130, 340, 200, 500, 250, 350,130, 340, 200, 500, 250, 350, 500]
          ["x", ...x],
          ["Prev Pending", ...Prev_Pending_To_Assign],
          ["Pending Assign", ...Pending_To_Assign ],
          // ["x", "00:01", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"],
          // ["Previous Day", 0, 0, 0, 0, 0, 2, 0, 0, 19, 26, 53, 54, 46, 34, 44, 27, 34, 7, 3, 2, 3, 6, 13, 5],
          // ["Today",        1, 0, 0, 0, 0, 6, 0, 0, 8, 24, 49, 44, 33, 27, 12, 0, 0, 0, 0, 0, 0, 15, 35, 0]
          
          
        ],
        type: "line", // Specify the chart type
      },
      axis: {
        x: {
          type: "timeseries", // Define the x-axis type as timeseries
          // localtime: true,   // Use UTC or not
          tick: {
            // format: "%H:%M",  // Display the time in hour:minute format
            // fit: true,        // Ensure the ticks fit into the chart
            // multiline: true,
            // rotate: 65,
            centered: true,    
            fit: true,
            format: "%H:%M",
          },
        },
      },
      bar: {
        width: {
          ratio: 0.5, 
        },
      },
      color: {
        pattern: ["#FF8000", "#C5A467"], 
      },
      grid: {
        x: {
          show: true, // Enable vertical gridlines
        },
      },
      size: {
        height: 160, // Set chart height
      },
      bindto: "#pendingAssign",
    });
  }


  initPicKing(x, Prev_Picking, Today_Picking): void {
    bb.generate({
      data: {
        x: "x",
        xFormat: "%H:%M", // Define the format of the x-axis data
        columns: [
          // Define the x-axis values as actual time strings
          // ["x", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00"],
          // ["Previous Day", 30, 200, 100, 400, 150, 250, 30, 200, 100, 400, 150, 250, 400],
          // ["Today", 130, 340, 200, 500, 250, 350,130, 340, 200, 500, 250, 350, 500]
          ["x", ...x],
          ["Prev Picked", ...Prev_Picking],
          ["Today Picked", ...Today_Picking ],
        ],
        type: "line", // Specify the chart type
      },
      axis: {
        x: {
          type: "timeseries", // Define the x-axis type as timeseries
          // localtime: true,   // Use UTC or not
          tick: {
            // format: "%H:%M",  // Display the time in hour:minute format
            // fit: true,        // Ensure the ticks fit into the chart
            // multiline: true,
            // rotate: 65,
            centered: true,    
            fit: true,
            format: "%H:%M",
          },
        },
      },
      bar: {
        width: {
          ratio: 0.5, 
        },
      },
      color: {
        pattern: ["#FF8000", "#A862A6"], 
      },
      grid: {
        x: {
          show: true, // Enable vertical gridlines
        },
      },
      size: {
        height: 160, // Set chart height
      },
      bindto: "#picKing",
    });
  }


  initChecKing(x, Prev_Checked, Today_Checked): void {
    bb.generate({
      data: {
        x: "x",
        xFormat: "%H:%M", // Define the format of the x-axis data
        columns: [
          // Define the x-axis values as actual time strings
          // ["x", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00"],
          // ["Previous Day", 30, 200, 100, 400, 150, 250, 30, 200, 100, 400, 150, 250, 400],
          // ["Today", 130, 340, 200, 500, 250, 350,130, 340, 200, 500, 250, 350, 500]
          ["x", ...x],
          ["Prev Checked", ...Prev_Checked],
          ["Today Checked", ...Today_Checked ],
        ],
        type: "line", // Specify the chart type
      },
      axis: {
        x: {
          type: "timeseries", // Define the x-axis type as timeseries
          // localtime: true,   // Use UTC or not
          tick: {
            // format: "%H:%M",  // Display the time in hour:minute format
            // fit: true,        // Ensure the ticks fit into the chart
            // multiline: true,
            // rotate: 65,
            centered: true,    
            fit: true,
            format: "%H:%M",
          },
        },
      },
      bar: {
        width: {
          ratio: 0.5, 
        },
      },
      color: {
        pattern: ["#FF8000", "#A9C56F"], 
      },
      grid: {
        x: {
          show: true, // Enable vertical gridlines
        },
      },
      size: {
        height: 160, // Set chart height
      },
      bindto: "#checKing",
    });
  }


  initDisPatch(x, Prev_Dispatched, Today_Dispatched): void {
    bb.generate({
      data: {
        x: "x",
        xFormat: "%H:%M", // Define the format of the x-axis data
        columns: [
          // Define the x-axis values as actual time strings
          // ["x", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00"],
          // ["Previous Day", 30, 200, 100, 400, 150, 250, 30, 200, 100, 400, 150, 250, 400],
          // ["Today", 130, 340, 200, 500, 250, 350,130, 340, 200, 500, 250, 350, 500]
          ["x", ...x],
          ["Prev Dispatched", ...Prev_Dispatched],
          ["Today Dispatched", ...Today_Dispatched ],
        ],
        type: "line", // Specify the chart type
      },
      axis: {
        x: {
          type: "timeseries", // Define the x-axis type as timeseries
          // localtime: true,   // Use UTC or not
          tick: {
            // format: "%H:%M",  // Display the time in hour:minute format
            // fit: true,        // Ensure the ticks fit into the chart
            // multiline: true,
            // rotate: 65,
            centered: true,    
            fit: true,
            format: "%H:%M",
          },
        },
      },
      bar: {
        width: {
          ratio: 0.5, 
        },
      },
      color: {
        pattern: ["#FF8000", "#59A97B"], 
      },
      grid: {
        x: {
          show: true, // Enable vertical gridlines
        },
      },
      size: {
        height: 160, // Set chart height
      },
      bindto: "#disPatch",
    });
  }
  

  warehouseDashboardSummary: any = {
    "Total_Bills": 0,
    "Pending_To_Assign": 0,
    "Picked": 0,
    "Checked": 0,
    "Dispatched": 0,
    "Row_Load":0,
    "Picking":0,
    "Checking":0,
    "Total_Pending_To_Assign": 0,
  };
  Total_Bills_Graph: any[] = [];
  getWarehouseDashboardSummary(): void {
    const reqPayload = {
      Unit_ID: this.unitInfo.Unit_ID,
      Company_ID: this.unitInfo.Company_ID,
      Doc_Date: moment(this.selecteDate).format('YYYY-MM-DD'),
    };

    this.busy = this.http.post('api/warehouses/GetWarehouseDashboardSummary_V2', reqPayload)
      .subscribe((response: {
        Total_HeaderCount: any[],
        Total_Bills_Graph: any[],
        Pending_To_Assign_Graph: any[],
        Picking_Graph: any[],
        Checking_Graph: any[],
        Dispached_Graph: any[]
      }) => {
        // console.log(response);
        if (response.Total_HeaderCount.length > 0) {
          this.warehouseDashboardSummary = response.Total_HeaderCount[0];
        }
        if (response.Total_Bills_Graph.length > 0) {
          this.Total_Bills_Graph = response.Total_Bills_Graph;
          // this.initTotalBillsGraph(response.Total_Bills_Graph);
          let x = this.Total_Bills_Graph.map((item) => `${item.THr}:00`);
          let PrevDay_Inv_Count = this.Total_Bills_Graph.map((item) => item.PrevDay_Inv_Count);
          let Today_Inv_Count = this.Total_Bills_Graph.map((item) => item.Today_Inv_Count);
          this.inittotalBills(x, PrevDay_Inv_Count, Today_Inv_Count);
        }
        if (response.Pending_To_Assign_Graph.length > 0) {
          let x = response.Pending_To_Assign_Graph.map((item) => `${item.THr}:00`);
          let Prev_Pending_To_Assign = response.Pending_To_Assign_Graph.map((item) => item.Prev_Pending_To_Assign);
          let Pending_To_Assign = response.Pending_To_Assign_Graph.map((item) => item.Pending_To_Assign);
          this.initPendingAssign(x, Prev_Pending_To_Assign, Pending_To_Assign);
        }
        if (response.Picking_Graph.length > 0) {
          let x = response.Picking_Graph.map((item) => `${item.THr}:00`);
          let Prev_Picking = response.Picking_Graph.map((item) => item.Prev_Picked);
          let Today_Picking = response.Picking_Graph.map((item) => item.Today_Picked);
          this.initPicKing(x, Prev_Picking, Today_Picking);
        }
        if (response.Checking_Graph.length > 0) {
          let x = response.Checking_Graph.map((item) => `${item.THr}:00`);
          let Prev_Checked = response.Checking_Graph.map((item) => item.Prev_Checked);
          let Today_Checked = response.Checking_Graph.map((item) => item.Today_Checked);
          this.initChecKing(x, Prev_Checked, Today_Checked);
        }
        if (response.Dispached_Graph.length > 0) {
          let x = response.Dispached_Graph.map((item) => `${item.THr}:00`);
          let Prev_Dispatched = response.Dispached_Graph.map((item) => item.Prev_Dispatch_Count);
          let Today_Dispatched = response.Dispached_Graph.map((item) => item.Today_Dispatch_Count);
          this.initDisPatch(x, Prev_Dispatched, Today_Dispatched);
        }
      });
  }

  trackByFnRouteWise(index: number, item: any): number {
    return item.Route_Code;
  }

  routewise: any[] = [];
  billwise: any[] = [];
  pendingToAssign: any[] = [];
  picking: any[] = [];
  checking: any[] = [];
  dispached: any[] = [];
  dispachedRW: any[] = [];
  dispachedSM: any[] = [];
  RackLoadData: any[] = [];
  rackloadDetails: any[] = [];
  salesmanwise: any[] = [];
  areawise: any [] = [];
  RackLoadDetailscolumnDefs: any;
  todayPicker: any = {
    "Picker_Name": "",
  };
  todayChecker: any = {
    "Checker_Name": "",
  };
  checkerStatusCount: any = {
    "active":0,
    "inactive":0
  };
  pickerStatusCount: any = {
    "active":0,
    "inactive":0
  };
  routeStatus: any = { delay:0, onTime:0, superDelay:0 };
  GetWarehouseDashboardDetail(Type = "TB", SubType = "BW"): void {
    const requestPayload = {
      "Company_ID": this.unitInfo.Company_ID,
      "Unit_ID": this.unitInfo.Unit_ID,
      "Doc_Date": moment(this.selecteDate).format('YYYY-MM-DD'), 
      "Type": Type,
      "SubType": SubType 
    };
    this.busy = this.http.post('api/warehouses/GetWarehouseDashboardDetail_V2', requestPayload)
      .subscribe((response: any = {
        billwise: [],
        pendingToAssign: [],
        picking: [],
        checking:[],
        dispached:[],
        routewise: [],
        rackload: [],
        salesmanwise: [],
        areawise: [],
      }) => {
        if(response){
          this.routewise =  response.routewise || []; 
          this.routeStatus = this.countPerformanceCategories(this.routewise);
          // console.log("this.countPerformanceCategories(this.routewise)", this.routeStatus);
          this.billwise = response.billwise || [] 
          // [
          //   { Bill_No: "SB-24-124998", Item_Count: "5", APT: "10", AT:"10", DT:"251"  }
          // ];
          this.pendingToAssign = response.pendingToAssign|| []

          this.picking = response.picking|| [];

          this.todayPicker =  this.getPickerOfTheDay(this.picking) || { Picker_Name: "" };
          this.pickerStatusCount = this.getPickerActiveInactiveCounts(this.picking);
          // console.log('🚀 ~ todayPicker:', this.todayPicker)
          this.checking = 
          response.checking|| []
          ;

          this.todayChecker =  this.getCheckerOfTheDay(this.checking) || { Checker_Name: "" };
          this.checkerStatusCount = this.getCheckerActiveInactiveCounts(this.checking);
          // console.log('🚀 ~ this.todayChecker:', this.todayChecker)

          this.dispachedRW = response.dispachedRW|| []

          this.dispachedSM = response.dispachedSM|| [] ;

          // this.rackLoadData = response.rackload || [];
          if(response.rackload && response.rackload.length > 0){
            this.RackLoadData = response.rackload;
            try {
              if(this.RackLoadData.length > 0){
               this.getBinDetails("RL","DL",this.RackLoadData[0].Bin_Name);
              }
            } catch (error) {
              console.log('🚀 ~ error:', error);
            }
          }else{
            this.RackLoadData = [];
            this.rackloadDetails = [];
          }
          if(response.rackloadDetails && response.rackloadDetails.length > 0){
            this.rackloadDetails = response.rackloadDetails || [];
          }else{
            this.rackloadDetails = [];
          }
          if(response.salesmanwise && response.salesmanwise.length> 0){
            this.salesmanwise = response.salesmanwise || [];
          }
          if(response.areawise && response.areawise.length> 0){
            this.areawise = response.areawise || [];
          }
        }
      });
  }

  // get totalBills_count(): number {
  //   return this.routewise.length + this.billwise.length
  // }

  trackByFnBillWise(index: number, item: any): number {
    return item.Bill_No;
  }

  trackByFnPendingToAssign(index: number, item: any): number {
    return item.Invoice_No;
  }

  trackByFnpicking(index: number, item: any): number {
    return item.Picker_Name;
  }

  trackByFnchecking(index: number, item: any): number {
    return item.Checker_Name;
  }

  trackByFnDispached(index: number, item: any): number {
    return item.Dispatch_No;
  }

  trackByFnSalesmanwise(index: number, item:any): number{
    return item.SNO;
  }

  onDateChange(event: any): void {
    // console.log('🚀 ~ event:', event)
    // this.selecteDate = event;
    this.getWarehouseDashboardSummary();
    // this.GetWarehouseDashboardDetail();
    this.activeWarehouse = 0;
    this.setactiveWarehouse(this.activeWarehouse);
  }

  getClass(value: number): string {
    if (value >= 100) return 'pr_green';
    if (value > 50 && value < 100) return 'pr_orange';
    return 'pr_red';
  }

  getRowClass(value: number): string {
    if (value >= 100) return 'pr_light_green';
    if (value > 50 && value < 100) return 'pr_light_orange';
    return 'pr_light_red';
  }

  getBillwiseClass(value: number): string {
    if (value <= 0) return 'pr_green';
    if (value > 0 && value < 4) return 'pr_orange';
    return 'pr_red';
  }
  getBillwiseRowClass(value: number): string {
    if (value <= 0) return 'pr_light_green';
    if (value > 0 && value < 4) return 'pr_light_orange';
    return 'pr_light_red';
  }

  getPickerOfTheDay(pickers: any[]): any {
    // Step 1: Find the max DT value
    let maxDT = Math.max(...pickers.map(picker => picker.DT));
  
    // Step 2: Filter all pickers having the same min DT
    let maxDTPickers = pickers.filter(picker => this.f_chknum(picker.DT) == this.f_chknum(maxDT));
  
    // Step 3: Find the picker with the highest Picked_Item_Count in case of tie
    return maxDTPickers.reduce((best, current) =>
      current.Picked_Item_Count > best.Picked_Item_Count ? current : best,
      maxDTPickers[0]
    );
  }

  getCheckerOfTheDay(checkers: any[]): any {
    // Step 1: Find the minimum DT value
    let maxDT = Math.max(...checkers.map(checker => checker.DT));
  
    // Step 2: Filter all pickers having the same min DT
    let maxDTCheckers = checkers.filter(checker => this.f_chknum(checker.DT) == this.f_chknum(maxDT));
  
    // Step 3: Find the picker with the highest Checked_Item_Count in case of tie
    return maxDTCheckers.reduce((best, current) =>
      current.Checked_Item_Count > best.Checked_Item_Count ? current : best,
      maxDTCheckers[0]
    );
  }

  getCheckerActiveInactiveCounts(checkers: any[]): any {
    let active = 0;
    let inactive = 0;
    checkers.forEach(checker => {
      if (checker.Status =='Active') {
        active++;
      } else {
        inactive++;
      }
    });
    return { active, inactive };
  }
  getPickerActiveInactiveCounts(checkers: any[]): any {
    let active = 0;
    let inactive = 0;
    checkers.forEach(checker => {
      if (checker.Status =='Active') {
        active++;
      } else {
        inactive++;
      }
    });
    return { active, inactive };
  }


  countPerformanceCategories(routes: any[]) {
    return routes.reduce(
      (acc, route) => {
        let performance = parseFloat(route.OTIFPerformance); // Convert string to number
  
        if (performance >= 100) {
          acc.onTime++;
        } else if (performance > 50 && performance < 100) {
          acc.delay++;
        } else {
          acc.superDelay++;
        }
  
        return acc;
      },
      { superDelay: 0, delay: 0, onTime: 0 } // ✅ Initial values
    );
  }


  f_chkString(p_value) {
    var Val = (p_value ? p_value.toString() : "").trim();
    return Val;
}

f_chknum(p_value) {
    var Val = Number(p_value);
    if (Val) {
        return Val;
    }
    return 0;
}
  onRefresh(): void {
    this.activeWarehouse = 0;
    this.getWarehouseDashboardSummary();
    this.GetWarehouseDashboardDetail();
  }

  autoCycleIndex = -1;      // So the first "start" moves us to index=0
  autoCycleTimer: any = null;  // Will store the `setTimeout` reference
  tileAutoCycleConfig = [
    { warehouseId: 1, interval: 2 , routeWiseInterval: 2, billWiseInterval:2},  // 5 seconds for "Total Bills"
    { warehouseId: 2, interval: 2 }, // 10 seconds for "Pending to Assign"
    { warehouseId: 3, interval: 2 },  // skip "Picking" tile (0 = skip)
    { warehouseId: 4, interval: 2 },  // 7 seconds for "Checking"
    { warehouseId: 5, interval: 2, dispatchRouteInterval:2, dispatchSalesmanInterval:2 },  // 5 seconds for "Dispatch"
    { warehouseId: 6, interval: 2 },  // 5 seconds for "Dispatch"
    
  ];
  routewiseTileTimer: number = 10; // 10 seconds for "Total Routewise"

  isCycling: boolean = false;
  // startAutoCycle(): void {
  //   // Clear any previous timer
  //   if (this.autoCycleTimer) {
  //     clearTimeout(this.autoCycleTimer);
  //     this.autoCycleTimer = null;
  //   }
  //   // Move index to the next valid tile
  //   do {
  //     this.autoCycleIndex = (this.autoCycleIndex + 1) % this.tileAutoCycleConfig.length;
  //   } while (this.tileAutoCycleConfig[this.autoCycleIndex].interval === 0);

  //   // Get the tile config
  //   const currentTile = this.tileAutoCycleConfig[this.autoCycleIndex];

  //   // Activate that tile via your existing method
  //   this.setactiveWarehouse(currentTile.warehouseId);

  //   // Now schedule the next rotation
  //   // this.autoCycleTimer = setTimeout(() => {
  //   //   this.startAutoCycle();
  //   // }, currentTile.interval * 1000);

  //   // 4. Schedule the next rotation
  //   const interval = currentTile.interval;
  //   if (interval !== 0) {
  //     this.autoCycleTimer = setTimeout(() => {
  //       this.startAutoCycle();
  //     }, interval * 1000);
  //   } else {
  //     // If 0, skip immediately
  //     this.startAutoCycle();
  //   }

  //   this.isCycling = true;  // ✅ Mark as running
  // }

  startAutoCycle(): void {
    // 1. Clear existing timer
    if (this.autoCycleTimer) {
      clearTimeout(this.autoCycleTimer);
      this.autoCycleTimer = null;
    }

    // 2. Ensure tileAutoCycleConfig is valid
    if (!this.tileAutoCycleConfig || this.tileAutoCycleConfig.length === 0) {
      console.warn("🚨 tileAutoCycleConfig is empty. Auto-cycle cannot proceed.");
      return;
    }

    // 3. Ensure autoCycleIndex is within valid bounds
    if (this.autoCycleIndex < 0 || this.autoCycleIndex >= this.tileAutoCycleConfig.length) {
      console.warn("🚨 Invalid autoCycleIndex. Resetting to 0.");
      this.autoCycleIndex = 0;
    }

    // 4. Get the current tile safely
    const currentTile = this.tileAutoCycleConfig[this.autoCycleIndex];
    if (!currentTile) {
      console.warn("🚨 Current tile is undefined. Skipping cycle.");
      return;
    }

    console.log(`🔥 Switching to warehouseId: ${currentTile.warehouseId}`);

    // 2. Get the current tile from the cycle
    // const currentTile = this.tileAutoCycleConfig[this.autoCycleIndex];

    // // 3. Special handling for "Total Bill" tile
    // if (currentTile.warehouseId === 1) { // Assuming TB = warehouseId 1
    //   this.setactiveWarehouse(1); // Activate "Total Bill"
    //   this.activeCstabs = 2; // Route Wise
    //   this.setactiveCstabs(2);
    //   this.autoCycleTimer = setTimeout(() => {
    //     this.activeCstabs = 1; // Bill Wise
    //     this.setactiveCstabs(1);
    //     this.autoCycleTimer = setTimeout(() => {
    //       this.moveToNextTile();
    //     }, 10 * 1000); // After 10 seconds, move to next tile
    //   }, 10 * 1000); // After 10 seconds, switch to Bill Wise
    //   return;
    // }
    if (currentTile.warehouseId === 1) { // TB tile
      this.setactiveWarehouse(1);
      this.setactiveCstabs(2); // Route Wise tab
      this.autoCycleTimer = setTimeout(() => {
        this.setactiveCstabs(1); // Switch to Bill Wise tab
        this.autoCycleTimer = setTimeout(() => {
          this.moveToNextTile(); // Move to next tile after 10 sec
        }, currentTile.routeWiseInterval * 60 * 1000);
      }, currentTile.billWiseInterval * 60 * 1000);
      return;
    }

    // 4. Special handling for "Dispatch" tile
    if (currentTile.warehouseId === 5) { // DP tile
      this.setactiveWarehouse(5);
      this.setactiveDispatchTabs(1); // Route Wise tab
      this.autoCycleTimer = setTimeout(() => {
        this.setactiveDispatchTabs(2); // Switch to Salesman Wise tab
        this.autoCycleTimer = setTimeout(() => {
          this.moveToNextTile(); // Move to next tile after 10 sec
        }, currentTile.dispatchSalesmanInterval * 60 * 1000);
      }, currentTile.dispatchRouteInterval * 60 * 1000);
      return;
    }

    // 5. If it's not "Total Bill" or "Dispatch", continue normal cycling
    this.moveToNextTile();
  }

  moveToNextTile(): void {
    // 1. Clear any existing timer
    if (this.autoCycleTimer) {
      clearTimeout(this.autoCycleTimer);
      this.autoCycleTimer = null;
    }

    // 2. Move to the next valid tile
    do {
      this.autoCycleIndex = (this.autoCycleIndex + 1) % this.tileAutoCycleConfig.length;
    } while (this.tileAutoCycleConfig[this.autoCycleIndex].interval === 0);

    // 3. Activate the new tile
    const nextTile = this.tileAutoCycleConfig[this.autoCycleIndex];
    this.setactiveWarehouse(nextTile.warehouseId);
    this.getWarehouseDashboardSummary();
    // 4. Start the next cycle
    const interval = nextTile.interval;
    if (interval !== 0) {
      this.autoCycleTimer = setTimeout(() => {
        this.startAutoCycle();
      }, interval * 60 * 1000);
    } else {
      this.startAutoCycle();
    }

    this.isCycling = true;  // ✅ Mark as running
  }


  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: Event): void {
    // Clear timer if needed
    if (this.autoCycleTimer) {
      clearTimeout(this.autoCycleTimer);
      this.autoCycleTimer = null;
    }
  }

  toggleAutoCycle(): void {
    if (this.isCycling) {
      // If cycling, stop it
      if (this.autoCycleTimer) {
        clearTimeout(this.autoCycleTimer);
        this.autoCycleTimer = null;
      }
      this.isCycling = false;  // 🚫 Mark as paused
    } else {
      // If paused, restart the cycle
      this.startAutoCycle();
    }
  }

  // get tableHeaders(): string[] {
  //   return this.rackLoadData.length > 0 ? Object.keys(this.rackLoadData[0]) : [];
  // }

  // generateColumns(data: any[]) {
  //   let columnDefinitions = [];
  //   data.map(object => {
  //     Object
  //       .keys(object)
  //       .map(key => {
  //         let mappedColumn = {
  //           headerName: key.toUpperCase(),
  //           field: key,
  //           width: 70,
  //           cellStyle: { 'textAlign': "right" }
  //         }
  //         columnDefinitions.push(mappedColumn);
  //       })
  //   })
  //   columnDefinitions = columnDefinitions.filter((column, index, self) =>
  //     index === self.findIndex((colAtIndex) => (
  //       colAtIndex.field === column.field
  //     ))
  //   )
  //   return columnDefinitions;
  // }

  get tableHeaders(): string[] {
    return this.RackLoadData.map(item => item.Bin_Name); // Extract Bin_Name as headers
  }

  get tableValues(): number[] {
    return this.RackLoadData.map(item => item.Bin_Count); // Extract Bin_Count as row values
  }


  get tableHeaderDetails(): string[] {
    return this.rackloadDetails.map(item => item.Bin_Name); // Extract Bin_Name as headers
  }

  get tableValueDetails(): number[] {
    return this.rackloadDetails.map(item => item.Bin_Count); // Extract Bin_Count as row values
  }


  getBinDetails(Type = "RL", SubType = "DL", Bin_Name): void {
    const requestPayload = {
      "Company_ID": this.unitInfo.Company_ID,
      "Unit_ID": this.unitInfo.Unit_ID,
      "Doc_Date": moment(this.selecteDate).format('YYYY-MM-DD'),
      "Type": Type,
      "SubType": SubType,
      "Bin_Name": Bin_Name
    };
    this.busy = this.http.post('api/warehouses/GetWarehouseDashboardDetail', requestPayload)
      .subscribe((response: any = {
        rackloadDetails: []
      }) => {
        if (response.rackloadDetails && response.rackloadDetails.length > 0) {
          this.rackloadDetails = response.rackloadDetails || [];
        } else {
          this.rackloadDetails = [];
        }
      });
  }
  selectedCellIndex: any;
  getBinDetailsUsingHeader(header: string, index = 0): void {
    this.getBinDetails("RL", "DL", header);
    console.log('clicked::', header);
    this.selectedCellIndex = index; // Store the clicked cell index
  }

  editedConfig: any[] = [];
  validationErrors: { [key: string]: boolean }[] = [];

  openCycleConfig(): void {
    this.validationErrors = this.editedConfig.map(() => ({}));
    this.editedConfig = JSON.parse(JSON.stringify(this.tileAutoCycleConfig));
    // this.validationErrors = new Array(this.editedConfig.length).fill(false);


    this.cycleConfigReference = this.modalService.open(this.CycleConfig, { size: 'lg', windowClass: 'data-show width-60 height-400', centered: true, keyboard: true, backdrop: 'static', });

    this.cycleConfigReference.result.then((result) => {
      console.log('result', result);
    }, (reason) => {
      console.log('reason', reason);
    });
  }

  // validateInput(index: string): void {

  //   const value = this.f_check_number(this.editedConfig[index].interval);
  //   this.validationErrors[index] = !(Number.isInteger(value) && value >= 0);
  // }

  validateInput(index: number, field: 'interval' | 'billWiseInterval' | 'routeWiseInterval' | 'dispatchRouteInterval' | 'dispatchSalesmanInterval'): void {
    if (!this.validationErrors[index]) {
      this.validationErrors[index] = {}; // Ensure object exists
    }

    const value = this.f_check_number(this.editedConfig[index][field]);
    this.validationErrors[index][field] = !(Number.isInteger(value) && value >= 0);
  }
  OkClicked() {
    // if (this.validationErrors.some(err => err)) {
    //   this.toastWarningMsg("Please correct invalid values before saving.");
    //   return;
    // }
    const isValid = this.editedConfig.every(config => 
      this.f_check_number(config.interval) && this.f_check_number(config.interval) >= 0 &&
      (config.routeWiseInterval === undefined || (this.f_check_number(config.routeWiseInterval) && this.f_check_number(config.routeWiseInterval) >= 0)) &&
      (config.billWiseInterval === undefined || (this.f_check_number(config.billWiseInterval) && this.f_check_number(config.billWiseInterval) >= 0))
    );
  
    if (!isValid) {
      this.toastWarningMsg("Please correct invalid values before saving.");
      return;
    }

    // if (this.validationErrors.some(err => Object.values(err).some(value => value))) {
    //   this.toastWarningMsg("Please correct invalid values before saving.");
    //   return;
    // }
    console.log("JSON.parse(JSON.stringify(this.editedConfig))", JSON.parse(JSON.stringify(this.editedConfig)));

    this.tileAutoCycleConfig = JSON.parse(JSON.stringify(this.editedConfig));
    this.toastWarningMsg("Configuration saved successfully.");
    this.cycleConfigReference.close();
    this.startAutoCycle();
  }

  toast = Swal.mixin({
    toast: true,
    position: 'center',
    showConfirmButton: false,
    timer: 3000,
    backdrop: `rgba(30, 30, 37, 0.4)`
  });
  toastWarningMsg(msg) {
    this.toast({
      type: 'warning',
      title: msg
    });
  }

  warehouseNames: { [key: number]: string } = {
    1: "Total Billwise",
    2: "Pending to Assign",
    3: "Picking",
    4: "Checking",
    5: "Dispatch",
    6: "Row Load",
    7: "Total Routewise"
  };

  getWarehouseName(warehouseId: number): string {
    return this.warehouseNames[warehouseId] || "Unknown";
  }

  f_check_string(p_value) {
    if (p_value == undefined || p_value === '' || p_value === null || p_value !== p_value) {
      return "";
    } else {
      return p_value;
    }
  }
  f_check_number(p_value) {
    if (p_value == undefined || p_value === '' || p_value === null || p_value !== p_value) {
      return 0;
    } else {
      return Number(p_value);
    }
  }

  sortColumn: string | null = null;
  sortDirection: 'asc' | 'desc' = 'asc';
  // sortTable(column: string, data:any[]=[]) {
  //   // this.sortDirection = 'asc';
  //   try {
  //     if (this.sortColumn === column) {
  //       this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  //     } else {
  //       this.sortColumn = column;
  //       this.sortDirection = 'asc';
  //     }
  
  //     data.sort((a, b) => {
  //       const valueA = a[column];
  //       const valueB = b[column];
  
  //       if (typeof valueA === 'string') {
  //         return this.sortDirection === 'asc'
  //           ? valueA.localeCompare(valueB)
  //           : valueB.localeCompare(valueA);
  //       } else {
  //         return this.sortDirection === 'asc' ? valueA - valueB : valueB - valueA;
  //       }
  //     });
  //   } catch (err) {
  //     console.error('sortTable:',err);
  //   }
  // }
  sortTable(column: string, data: any[]) {
    try {
      // Add original index if not already set
      if (!data.some(item => item.hasOwnProperty('originalIndex'))) {
        data.forEach((item, index) => item.originalIndex = index);
      }
  
      if (this.sortColumn === column) {
        if (this.sortDirection === 'asc') {
          this.sortDirection = 'desc';
        } else if (this.sortDirection === 'desc') {
          this.sortDirection = null;
          this.sortColumn = null;
          data.sort((a, b) => a.originalIndex - b.originalIndex); // Reset to original order
          return;
        } else {
          this.sortDirection = 'asc';
        }
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
  
      if (this.sortDirection) {
        data.sort((a, b) => {
          const valueA = a[column];
          const valueB = b[column];
  
          if (typeof valueA === 'string') {
            return this.sortDirection === 'asc'
              ? valueA.localeCompare(valueB)
              : valueB.localeCompare(valueA);
          } else {
            return this.sortDirection === 'asc' ? valueA - valueB : valueB - valueA;
          }
        });
      }
    } catch (err) {
      console.error('sortTable:', err);
    }
  }

  getSortIcon(column: string) {
    if (this.sortColumn === column) {
      // return this.sortDirection === 'asc' ? '▲' : '▼';
      if(!this.sortDirection){
        return '';
      }
      return this.sortDirection === 'asc' ?  '⬇️':'⬆️';
    }
    return '';
  }

  
  sortByColumnBillwise(column: string) {
    this.sortTable(column, this.billwise);
  }

  sortByColumnRouteWise(column: string) {
    this.sortTable(column, this.routewise);
  }

  sortByColumnSalesmanwise(column: string) {
    this.sortTable(column, this.salesmanwise);
  }

  sortByColumnAreawise(column: string) {
    this.sortTable(column, this.areawise);
  }

  sortByColumnPendingToAssign(column: string) {
    this.sortTable(column, this.pendingToAssign);
  }

  sortByColumnPicking(column: string) {
    this.sortTable(column, this.picking);
  }

  sortByColumnChecking(column: string) {
    this.sortTable(column, this.checking);
  }
  sortByColumnDispatchRW(column: string) {
    this.sortTable(column, this.dispachedRW);
  }

  sortByColumnDispatchSM(column: string) {
    this.sortTable(column, this.dispachedSM);
  }
  
  // demochartOption: EChartOption = {};
  // demoChart:any;
  // demoChartData: any = [
  //   {
  //     "CPTDate": "2025-03-16 13:00:00",
  //     "OrdersCount": 24,
  //     "InvoiceCount": 24,
  //     "PendingCount": 0,
  //     "FailedCount": 0,
  //     "PickedCount": 24,
  //     "PendingPicked": 0
  //   },
  //   {
  //     "CPTDate": "2025-03-17 01:30:00",
  //     "OrdersCount": 241,
  //     "InvoiceCount": 241,
  //     "PendingCount": 0,
  //     "FailedCount": 0,
  //     "PickedCount": 235,
  //     "PendingPicked": 6
  //   },
  //   {
  //     "CPTDate": "2025-03-17 13:00:00",
  //     "OrdersCount": 1729,
  //     "InvoiceCount": 1729,
  //     "PendingCount": 0,
  //     "FailedCount": 0,
  //     "PickedCount": 1717,
  //     "PendingPicked": 12
  //   },
  //   {
  //     "CPTDate": "2025-03-18 01:30:00",
  //     "OrdersCount": 276,
  //     "InvoiceCount": 276,
  //     "PendingCount": 0,
  //     "FailedCount": 0,
  //     "PickedCount": 203,
  //     "PendingPicked": 73
  //   },
  //   {
  //     "CPTDate": "2025-03-18 13:00:00",
  //     "OrdersCount": 4255,
  //     "InvoiceCount": 4246,
  //     "PendingCount": 0,
  //     "FailedCount": 9,
  //     "PickedCount": 1743,
  //     "PendingPicked": 2503
  //   },
  //   {
  //     "CPTDate": "2025-03-19 13:00:00",
  //     "OrdersCount": 1124,
  //     "InvoiceCount": 1122,
  //     "PendingCount": 0,
  //     "FailedCount": 2,
  //     "PickedCount": 3,
  //     "PendingPicked": 1119
  //   },
  //   {
  //     "CPTDate": "2025-03-20 13:00:00",
  //     "OrdersCount": 167,
  //     "InvoiceCount": 166,
  //     "PendingCount": 0,
  //     "FailedCount": 1,
  //     "PickedCount": 1,
  //     "PendingPicked": 165
  //   },
  //   {
  //     "CPTDate": "2025-03-21 13:00:00",
  //     "OrdersCount": 39,
  //     "InvoiceCount": 39,
  //     "PendingCount": 0,
  //     "FailedCount": 0,
  //     "PickedCount": 0,
  //     "PendingPicked": 39
  //   },
  //   {
  //     "CPTDate": "2025-03-31 13:00:00",
  //     "OrdersCount": 2,
  //     "InvoiceCount": 2,
  //     "PendingCount": 0,
  //     "FailedCount": 0,
  //     "PickedCount": 0,
  //     "PendingPicked": 2
  //   },
  //   {
  //     "CPTDate": "2025-04-01 13:00:00",
  //     "OrdersCount": 1,
  //     "InvoiceCount": 1,
  //     "PendingCount": 0,
  //     "FailedCount": 0,
  //     "PickedCount": 0,
  //     "PendingPicked": 1
  //   }
  // ];
  // onChartInitDemo($event){
  //   this.demoChart = $event;
  //   this.demochartOption = {
  //     grid:{
  //       feature:{
  //         show: true,
  //         saveAsImage: {},
  //         magicType: {
  //           type: ['line', 'bar', 'stack', 'tiled'],
  //           show: true
  //         }
  //       }
  //     },
  //     tooltip: { trigger: 'axis' },
  //     legend: { data: ['Orders', 'Picked', 'Pending Picked'] },
  //     xAxis: { type: 'category', data: this.demoChartData.map(item => item.CPTDate) },
  //     yAxis: { type: 'value' },
  //     series: [
  //       { name: 'Orders', type: 'bar', data: this.demoChartData.map(item => item.OrdersCount) },
  //       { name: 'Picked', type: 'bar', data: this.demoChartData.map(item => item.PickedCount) },
  //       { name: 'Pending Picked', type: 'line', data: this.demoChartData.map(item => item.PendingPicked) }
  //     ]
  //   };

  // }

  getDrillType: string = '';
  getDrillDownDetails(Type = "TB", SubType = "BW", Route_Code = "", ID ): void {
    this.getDrillType = Type;
    // const keyName = Type == "TB" || 'PTA' ? "Transaction_No" : SubType  == 'SM' ? "Employee_ID": "Route_ID";
    let keyName = '';
    if (Type == "TB" || SubType == "PTA") {
      keyName = "Transaction_No";
    } else if (Type == 'DP' && SubType == "SM") {
      keyName = "Employee_ID";
    }else if (Type == 'DP' && SubType == "RW") {
      keyName = "Route_ID";
    }else {
      keyName = "Transaction_No";
    }
    const requestPayload = {
      "Company_ID": this.unitInfo.Company_ID,
      "Unit_ID": this.unitInfo.Unit_ID,
      "Doc_Date": moment(this.selecteDate).format('YYYY-MM-DD'),
      "Type": Type,
      "SubType": SubType,
      "Route_Code": Route_Code,
      [keyName]: ID
    };
    console.log('🚀 ~ requestPayload:', requestPayload)

    this.busy = this.http.post('api/warehouses/GetWarehouseDashboardDrillDetail', requestPayload)
      .subscribe((response: any = {
        billwiseDrill: [],
        pendingToAssignDrill: [],
        dispachedSMDrill: [],
        dispachedRWDrill: [],
      }) => {
        if(response.billwiseDrill && response.billwiseDrill.length > 0){
          this.billwiseDrillrows = response.billwiseDrill || [];
        }
        else if(response.pendingToAssignDrill && response.pendingToAssignDrill.length > 0){
          this.billwiseDrillrows = response.pendingToAssignDrill || [];
        }else if(response.dispachedSMDrill && response.dispachedSMDrill.length > 0){
          this.dispatchDrillrows = response.dispachedSMDrill || [];
        }
        else if(response.dispachedRWDrill && response.dispachedRWDrill.length > 0){
          this.dispatchDrillrows = response.dispachedRWDrill || [];
        }
        else{
          this.billwiseDrillrows = [];
          this.dispatchDrillrows = [];
        }
      });
    
  }

  billwiseDrillrows: any[] = [];
  dispatchDrillrows: any[] = [];
  billwiseDrillColDefs: any = [
    { headerName: 'Order No', field: 'OrderNo', width: 100,},
    { headerName: 'Order Date', field: 'OrderDate',width: 140,},
    { headerName: 'Order Status', field: 'Order_Status',width: 120,},
    { headerName: 'Product Code', field: 'Product_Code',width: 110,},
    { headerName: 'Product Desc', field: 'Product_Desc',width: 160,},
    { headerName: 'Status Desc', field: 'Status_Desc',width: 140, 
      // cellStyle: params => {
      //   if (String(params.value).includes("VERY FAST MOVING")) {
      //     return { backgroundColor: 'lightgreen', color: 'black' }
      //   } else if (String(params.value).includes("FAST MOVING")) {
      //     return { backgroundColor: 'yellow', color: 'black' }
      //   } else if (String(params.value).includes("MEDIUM MOVING")) {
      //     return { backgroundColor: 'red', color: 'white' }
      //   } else if (String(params.value).includes("SLOW-MOVING")) {
      //     return { backgroundColor: 'lightblue', color: 'black' }
      //   } else {
      //     return { backgroundColor: 'white', color: 'black' }
      //   }
      // }
    },
    { headerName: 'Batch No', field: 'Batch_No',width: 100, },
    { headerName: 'Expiry Date', field: 'Expiry_Date',width: 100, },
    { headerName: 'MRP', field: 'MRP',width: 100,cellStyle:params =>  { return {textAlign: 'right'} } },
    { headerName: 'Sale Rate', field: 'Rate',width: 100,cellStyle:params =>  { return {textAlign: 'right'} } },
    { headerName: 'Qty', field: 'Entry_Qty',width: 70, cellStyle: params => {return{ textAlign: 'right',} } },
    { headerName: 'Free Qty', field: 'Free_Qty',width: 70,cellStyle: params => { return {textAlign: 'right'} } },
    { headerName: 'Created By', field: 'CreatedBy',width: 110,},
  ];

  dispatchDrillColDefs: any = [
    { headerName: 'Dispatch No', field: 'Dispatch_No',width: 100,}, 
    { headerName: 'Dispatch Date', field: 'Dispatch_Date',width: 100,}, 
    { headerName: 'Dispatched By', field: 'DispatchedBy',width: 110,}, 
    { headerName: 'Dispatched On', field: 'DispatchedOn',width: 140,}, 
    { headerName: 'Invoice No', field: 'Invoice_No', width: 100,},
    { headerName: 'Invoice Date', field: 'Invoice_Date',width: 100,},
    { headerName: 'Invoice Amount', field: 'Invoice_Amount',width: 100,  cellStyle: params => { return {textAlign: 'right'} } },
    { headerName: 'Customer Code', field: 'Customer_Code',width: 100,},
    { headerName: 'Customer Name', field: 'Customer_Name',width: 180,},
    { headerName: 'Order No', field: 'OrderNo',width: 100,},
    { headerName: 'Order Date', field: 'OrderDate',width: 100,}, 
  ];

  DrillDefaultColDef = {
    sortable: true,
    resizable: true,
    animation: true,
  }
  gridApiDrill: any;
  gridColumnApiDrill: any;
  onGridReadyDrill(params){
    this.gridApiDrill = params.api;
    this.gridColumnApiDrill = params.columnApi;
    setTimeout(() => {
      this.gridApiDrill.sizeColumnsToFit();
    }, 300);
  }

  searchTextBillwise: string = '';
  searchBillWise(){
    this.gridApiDrill.setQuickFilter(this.searchTextBillwise);
  }

  exportBillwise(){
    let params = {
      fileName: 'drilldetail.csv',
      allColumns: true,
      onlySelected: false,
      skipHeader: false,
      columnSeparator: ',',
    };
    this.gridApiDrill.exportDataAsCsv(params);
  }


  searchTextDispatch: string = '';
  searchDispatch(){
    this.gridApiDispatch.setQuickFilter(this.searchTextDispatch);
  }

  exportDispatch(){
    let params = {
      fileName: 'dispatch_drill.csv',
      allColumns: true,
      onlySelected: false,
      skipHeader: false,
      columnSeparator: ',',
    };
    this.gridApiDispatch.exportDataAsCsv(params);
  }

  gridApiDispatch: any;
  gridColumnApiDispatch: any;
  onGridReadyDispatch(params){
    this.gridApiDispatch = params.api;
    this.gridColumnApiDispatch = params.columnApi;
    setTimeout(() => {
      this.gridApiDispatch.sizeColumnsToFit();
    }, 300);
  }


}